import { Controller } from "stimulus"

export default class extends Controller {

  onPostSuccess(event) {
    this.hideOverlayForm(event);
  }

  hideOverlayForm(event) {
  	event.target.getParent('.overlay-form').fireEvent('overlayFormHide');
  }
}